import { render, staticRenderFns } from "./InvoiceCreatePage.vue?vue&type=template&id=5c18db72&"
import script from "./InvoiceCreatePage.vue?vue&type=script&lang=ts&"
export * from "./InvoiceCreatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c18db72')) {
      api.createRecord('5c18db72', component.options)
    } else {
      api.reload('5c18db72', component.options)
    }
    module.hot.accept("./InvoiceCreatePage.vue?vue&type=template&id=5c18db72&", function () {
      api.rerender('5c18db72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trucking/account-receivable/InvoiceCreatePage.vue"
export default component.exports